import { render, staticRenderFns } from "./player-af-member.vue?vue&type=template&id=39ef3f40&"
import script from "./player-af-member.vue?vue&type=script&lang=js&"
export * from "./player-af-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports